import { createApi } from 'store/slices/createApi';
import { createBaseQuery } from '../../slices';
import { TAG_TYPES } from 'types/services';

export const documentStorageApi = createApi({
  reducerPath: 'documentStorageApi',
  baseQuery: createBaseQuery({
    extendedUrl: 'Documentstorage',
  }),

  tagTypes: [TAG_TYPES.FILES],

  endpoints: () => ({}),
});
